import { render, staticRenderFns } from "./ModeloCarteiraAporte.vue?vue&type=template&id=0856ba74&scoped=true"
import script from "./ModeloCarteiraAporte.vue?vue&type=script&lang=js"
export * from "./ModeloCarteiraAporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0856ba74",
  null
  
)

export default component.exports